import { createContext, useState, useCallback } from "react";
import SyncLoader from "react-spinners/SyncLoader";

const SpinnerContext = createContext();

export default SpinnerContext;

export function SpinnerContextProvider({ children }) {
  const [spinnerCount, setSpinnerCount] = useState(0);

  const showSpinnerHandler = useCallback((showSpinner) => {
    setSpinnerCount((prev) => (showSpinner ? prev + 1 : Math.max(0, prev - 1)));
  }, []);

  return (
    <SpinnerContext.Provider value={showSpinnerHandler}>
      {spinnerCount > 0 && (
        <div className="fixed inset-0 flex items-center justify-center">
          <div className="absolute inset-0 bg-black opacity-25 z-[80]" />
          <div className="relative z-[81]">
            <SyncLoader size={55} color="#30A375" />
          </div>
        </div>
      )}
      {children}
    </SpinnerContext.Provider>
  );
}
